import { render, staticRenderFns } from "./catLegend.vue?vue&type=template&id=1afb2887"
import script from "./catLegend.vue?vue&type=script&lang=js"
export * from "./catLegend.vue?vue&type=script&lang=js"
import style0 from "./catLegend.vue?vue&type=style&index=0&id=1afb2887&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports